import { AGNT_INC_WP_UPLOADS_URL } from 'constants/domains';

/** Canada regional privacy policy PDFs (EN + FR-CA), hosted on the AGNT WP media library. */
export const CANADA_PRIVACY_POLICY_PDFS = {
  en: `${AGNT_INC_WP_UPLOADS_URL}/2026/08/eXp-Privacy-Policy-Canada-en.pdf`,
  fr: `${AGNT_INC_WP_UPLOADS_URL}/2026/08/eXp-Politique-de-Confidentialite-Canada-fr.pdf`,
} as const;

// Public URL slugs for each localized privacy-policy page. These mirror the
// production slugs on expworldholdings.com. Changing a slug here updates every
// in-app link; the matching route file in src/pages/ must be renamed to match.
export const PRIVACY_POLICY_PATHS = {
  en: '/privacy-policy',
  es: '/es-privacy-policy',
  de: '/privacy-policy-de',
  fr: '/privacy-policy-french',
  frCa: '/privacy-policy-french-canadian',
  pt: '/privacy-policy-pt',
  ptBz: '/privacy-policy-pt-bz',
  it: '/privacy-policy-it',
  ja: '/privacy-policy-japanese',
  kr: '/privacy-policy-kr',
  ar: '/privacy-policy-arabic',
  tr: '/turkey-privacy-policy',
  euUk: '/eu-uk-regional-privacy-notice',
  euUkDe: '/eu-uk-regional-privacy-notice-de',
  euUkEs: '/eu-uk-regional-privacy-notice-es',
  euUkFr: '/eu-uk-regional-privacy-notice-fr',
  euUkGr: '/eu-uk-regional-privacy-notice-gr',
  euUkIt: '/eu-uk-regional-privacy-notice-it',
  euUkPl: '/eu-uk-regional-privacy-notice-pl',
  euUkPt: '/eu-uk-regional-privacy-notice-pt',
  usRegional: '/us-regional-privacy-rights-statement',
  caRights: '/ca-privacy-rights-statement',
  coRights: '/co-privacy-rights-statement',
  ctRights: '/ct-privacy-rights-statement',
  orRights: '/or-privacy-rights-statement',
  txRights: '/tx-privacy-rights-statement',
  utRights: '/ut-privacy-rights-statement',
  vaRights: '/va-privacy-rights-statement',
  hkEn: '/hong-kong-supp-privacy-notice-en',
  ecuadorEn: '/ecuador-supp-privacy-notice-en',
  ecuadorEs: '/ecuador-supp-privacy-notice-es',
} as const;

/**
 * In-app LINK targets for the localized privacy policy. The localized slugs above
 * redirect to the base `/privacy-policy`, so links point at the base page with a
 * `?lang=` param and let the GTranslate widget render the language — rather than
 * hopping through the redirect.
 *
 * Keep using {@link PRIVACY_POLICY_PATHS} for the canonical route slugs (page files,
 * redirect sources, and `LEGAL_ROUTES` matching); use this for anything that links.
 *
 * `?lang=` uses Google Translate codes. `frCa`/`ptBz` collapse to `fr`/`pt` (GTranslate
 * has no Canadian-French / Brazilian-Portuguese variant). NOTE: `ja` and `ko` are not yet
 * in the GTranslate widget config, so those links won't translate until they're added.
 */
export const PRIVACY_POLICY_LINKS = {
  en: '/privacy-policy',
  es: '/privacy-policy?lang=es',
  de: '/privacy-policy?lang=de',
  fr: '/privacy-policy?lang=fr',
  frCa: '/privacy-policy?lang=fr',
  pt: '/privacy-policy?lang=pt',
  ptBz: '/privacy-policy?lang=pt',
  it: '/privacy-policy?lang=it',
  ja: '/privacy-policy?lang=ja',
  kr: '/privacy-policy?lang=ko',
  ar: '/privacy-policy?lang=ar',
} as const;
